<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Disciplinary Case - Action</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="discAction.code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="discAction.desc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Classification"
              :class="classPadding"
              v-model="discAction.classDesc"
              clearable
              @click:clear="clearClass"
              readonly
            >
              <template slot="append">
                <v-icon @click.stop="searchClass">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <pagination :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </pagination>

      <v-dialog v-model="editDialog" width="700" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Code"
                  :class="classPadding"
                  v-model="editDiscAction.code"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Description"
                  :class="classPadding"
                  v-model="editDiscAction.desc"
                ></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
                <v-text-field
                  label="Classification"
                  :class="classPadding"
                  v-model="editDiscAction.classDesc"
                  clearable
                  @click:clear="clearClass"
                  readonly
                >
                  <template slot="append">
                    <v-icon @click.stop="searchClass">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="classDialog" width="700">
        <v-card>
          <v-card-title>
            <span class="headline">Disciplinary - Classification</span>
          </v-card-title>
          <v-card-text>
            <class-pagination>
              <template slot="actions" slot-scope="{ item }">
                <v-btn @click.stop="selectClass(item)" text outlined
                  >select</v-btn
                >
              </template>
            </class-pagination>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="classDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import Pagination from "./Pagination";
import ClassPagination from "../classfication/Pagination";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/discCaseAction";
export default {
  metaInfo: {
    title: "Disciplinary Case - Action",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    Pagination,
    ClassPagination
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    discAction: {},
    componentKey: 0,
    editDiscAction: {},
    editDialog: false,
    classDialog: false
  }),
  methods: {
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.discAction)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editDiscAction.code = rel.code;
      this.editDiscAction.desc = rel.desc;
      this.editDiscAction.classDesc = rel.classDesc;
      this.editDiscAction.classCode = rel.classCode;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.code}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.discAction = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.editDiscAction)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    clearClass() {
      if (this.editDialog) {
        this.editDiscAction.classCode = null;
        this.editDiscAction.classDesc = null;
      } else {
        this.discAction.classCode = null;
        this.discAction.classDesc = null;
      }
    },
    searchClass() {
      this.classDialog = true;
    },
    selectClass(item) {
      if (this.editDialog) {
        this.editDiscAction.classCode = item.code;
        this.editDiscAction.classDesc = item.desc;
      } else {
        this.discAction.classCode = item.code;
        this.discAction.classDesc = item.desc;
      }
      this.classDialog = false;
    }
  },
  created() {
    this.getUserAccessRights("DiscipAct");
  }
};
</script>